// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.reachusfirstpage-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0px;
  position: relative;
  box-sizing: border-box; /* Ensure padding and borders don't overflow */
  min-height: calc(100vh - nav-height); /* Ensure it doesn't exceed viewport */
  margin-top:70px;

}

/* Image section */
.reachusfirstpage-image-section {
  width: 60%;
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}


.reachusfirstpage-about-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Text section */
.reachusfirstpage-text-section {
  width: 85%;
  background-color: #2FAAC6;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -6%;
}

/* Diagonal shaded line */
.reachusfirstpage-container::before {
  content: "";
  position: absolute;
  z-index: 2;
  background: linear-gradient(
      to bottom right,
      #2FAAC6,
      rgba(214, 215, 219, 0)
  );
  pointer-events: none;
  left: 40%; /* Lean closer to the text section */
  width: 3%; /* Thicker line */
  height: 150%; /* Extends the line significantly */
  top: -25%;
  transform: skewX(-9deg) translate(-5px, 10px); /* Fine horizontal and vertical tuning */
}

.reachusfirstpage-text-section h1 {
  font-size: 3em;
  margin-bottom: 10px;
  z-index: 3;
  font-family: Arial, Helvetica, sans-serif;
}

.reachusfirstpage-text-section p {
  font-size: 1.5em;
  text-align: center;
  padding: 0 20px;
  z-index: 3;
}

.container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}

.image-wrapper {
  flex: 1 1;
}

.image {
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
}

.text-wrapper {
  flex: 2 1;
  padding: 10px;
}

.info-section {
  margin: 20px 0;
}

/* Responsive styling */
@media (max-width: 768px) {
  .reachusfirstpage-container {
      flex-direction: column; /* Stack sections vertically */
      height: auto; /* Adjust height for stacked layout */
  }

  .reachusfirstpage-image-section {
      width: 100%; /* Full width for the image section */
      height: 55vh; /* Half the viewport height */
      clip-path: none; /* Remove clip-path for a full rectangular display */
  }

  .reachusfirstpage-text-section {
      width: 100%; /* Full width for the text section */
      height: 35vh;
      margin-left: 0; /* Remove overlap */
      clip-path: none; /* Remove clip-path for a rectangular display */
      padding: 20px; /* Add padding for spacing */
  }

  .reachusfirstpage-text-section h1 {
      font-size: 2em; /* Adjust font size for smaller screens */
      margin-right: 30px;
  }

  .reachusfirstpage-text-section p {
      font-size: 1em; /* Adjust paragraph font size */
      margin-right: 15px;
  }

  .reachusfirstpage-container::before {
      display: none; /* Hide the diagonal line in mobile view */
  }
}




`, "",{"version":3,"sources":["webpack://./src/components/Reachusfirst/Reachusfirst.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB,EAAE,8CAA8C;EACtE,oCAAoC,EAAE,sCAAsC;EAC5E,eAAe;;AAEjB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,kBAAkB;EAClB,sDAAsD;AACxD;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV;;;;GAIC;EACD,oBAAoB;EACpB,SAAS,EAAE,oCAAoC;EAC/C,SAAS,EAAE,iBAAiB;EAC5B,YAAY,EAAE,mCAAmC;EACjD,SAAS;EACT,6CAA6C,EAAE,wCAAwC;AACzF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;MACI,sBAAsB,EAAE,8BAA8B;MACtD,YAAY,EAAE,qCAAqC;EACvD;;EAEA;MACI,WAAW,EAAE,qCAAqC;MAClD,YAAY,EAAE,6BAA6B;MAC3C,eAAe,EAAE,oDAAoD;EACzE;;EAEA;MACI,WAAW,EAAE,oCAAoC;MACjD,YAAY;MACZ,cAAc,EAAE,mBAAmB;MACnC,eAAe,EAAE,+CAA+C;MAChE,aAAa,EAAE,4BAA4B;EAC/C;;EAEA;MACI,cAAc,EAAE,yCAAyC;MACzD,kBAAkB;EACtB;;EAEA;MACI,cAAc,EAAE,+BAA+B;MAC/C,kBAAkB;EACtB;;EAEA;MACI,aAAa,EAAE,0CAA0C;EAC7D;AACF","sourcesContent":["/* Main container */\n.reachusfirstpage-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: 0px;\n  position: relative;\n  box-sizing: border-box; /* Ensure padding and borders don't overflow */\n  min-height: calc(100vh - nav-height); /* Ensure it doesn't exceed viewport */\n  margin-top:70px;\n\n}\n\n/* Image section */\n.reachusfirstpage-image-section {\n  width: 60%;\n  position: relative;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n\n.reachusfirstpage-about-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Text section */\n.reachusfirstpage-text-section {\n  width: 85%;\n  background-color: #2FAAC6;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n  margin-left: -6%;\n}\n\n/* Diagonal shaded line */\n.reachusfirstpage-container::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  background: linear-gradient(\n      to bottom right,\n      #2FAAC6,\n      rgba(214, 215, 219, 0)\n  );\n  pointer-events: none;\n  left: 40%; /* Lean closer to the text section */\n  width: 3%; /* Thicker line */\n  height: 150%; /* Extends the line significantly */\n  top: -25%;\n  transform: skewX(-9deg) translate(-5px, 10px); /* Fine horizontal and vertical tuning */\n}\n\n.reachusfirstpage-text-section h1 {\n  font-size: 3em;\n  margin-bottom: 10px;\n  z-index: 3;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.reachusfirstpage-text-section p {\n  font-size: 1.5em;\n  text-align: center;\n  padding: 0 20px;\n  z-index: 3;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n\n.image-wrapper {\n  flex: 1;\n}\n\n.image {\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n}\n\n.text-wrapper {\n  flex: 2;\n  padding: 10px;\n}\n\n.info-section {\n  margin: 20px 0;\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n  .reachusfirstpage-container {\n      flex-direction: column; /* Stack sections vertically */\n      height: auto; /* Adjust height for stacked layout */\n  }\n\n  .reachusfirstpage-image-section {\n      width: 100%; /* Full width for the image section */\n      height: 55vh; /* Half the viewport height */\n      clip-path: none; /* Remove clip-path for a full rectangular display */\n  }\n\n  .reachusfirstpage-text-section {\n      width: 100%; /* Full width for the text section */\n      height: 35vh;\n      margin-left: 0; /* Remove overlap */\n      clip-path: none; /* Remove clip-path for a rectangular display */\n      padding: 20px; /* Add padding for spacing */\n  }\n\n  .reachusfirstpage-text-section h1 {\n      font-size: 2em; /* Adjust font size for smaller screens */\n      margin-right: 30px;\n  }\n\n  .reachusfirstpage-text-section p {\n      font-size: 1em; /* Adjust paragraph font size */\n      margin-right: 15px;\n  }\n\n  .reachusfirstpage-container::before {\n      display: none; /* Hide the diagonal line in mobile view */\n  }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
